export enum ComponentType {
  Typography = 'Typography',
  Global = 'Global',
  Link = 'Link',
  Button = 'Button',
  Badge = 'Badge',
  Card = 'Card',
  Checklist = 'Checklist',
  Form = 'Form',
  Hotspot = 'Hotspot',
  TourStep = 'TourStep',
}

export enum ComponentName {
  Typography = 'Text',
  Global = 'Color',
  Link = 'Links',
  Button = 'Buttons',
  Badge = 'Badges',
  Card = 'Cards',
  Checklist = 'Checklists',
  Form = 'Forms',
  Hotspots = 'Hotspots',
  Tour = 'Tour',
}

export type VariantNode = {
  isHidden?: boolean;
  name: string;
  conditions:
    | { variant: string; variation?: string; color?: never; outline?: never }
    | {
        variant: string;
        variation?: never;
        color: string;
        outline?: string;
      };
};

export type VariantRulesSelectors = {
  [key: string]: {
    rules: Record<string, string>;
    imports?: Record<string, string>;
  };
};

export type VariantRule = {
  name: string;
  tagName?: string;
  isHidden?: boolean;
  selectors: VariantRulesSelectors;
};

export type VariantRules = {
  base: VariantRule;
  [key: string]: VariantRule;
};

export type Variants = {
  id: string;
  variants: VariantRuleStylesheet;
}[];

export type VariantRuleStylesheet = {
  Global: VariantRules;
  [key: string]: VariantRules;
};

export type VariantData = {
  variants: VariantRuleStylesheet;
  ownerId: number;
  entityPermissionId: number;
  id: number;
};

export type NewVariantData = VariantData & {
  newVariantId: string;
  updatedAt: string;
};

export enum Variable {
  BG_COLOR = '--background-color',
  FONT_FAMILY = '--font-family',
  FONT_SIZE = '--font-size',
  FONT_WEIGHT = '--font-weight',
  BORDER_RADIUS = '--border-radius',
  BORDER_WIDTH = '--border-width',
  BORDER_COLOR = '--border-color',
  BOX_SHADOW = '--box-shadow',
  DROP_SHADOW = '--drop-shadow',
  LINK_VISITED_COLOR = 'color', // visited pseudo does not allow variables
  TEXT_COLOR = '--color',
  TEXT_DECORATION = '--text-decoration',
  LINE_HEIGHT = '--line-height',
  LETTER_SPACING = '--letter-spacing',
  FONT_STYLE = '--font-style',
  MARGIN = '--margin',
  PADDING = '--padding',
  CURSOR = '--cursor',
  HEIGHT = '--height',
  WIDTH = '--width',
  CHECKBOX_COLOR_FILL = '--checkbox-color-fill',
  CHECKBOX_ARROW_COLOR = '--checkbox-checked-arrow-color',
  CHECKBOX_ITEM_BORDER_WIDTH = '--checklist-item-border-width',
  CHECKBOX_ITEM_BORDER_COLOR = '--checklist-item-border-color',
  CARD_STROKE_COLOR = '--card-stroke',
  CARD_STROKE_WIDTH = '--card-stroke-width',
  HOTSPOT_STROKE_COLOR = '--hotspot-stroke',
  HOTSPOT_STROKE_WIDTH = '--hotspot-stroke-width',
  BEACON_COLOR = '--beacon-color',
  TOUR_STROKE_COLOR = '--tour-stroke',
  TOUR_STROKE_WIDTH = '--tour-stroke-width',
}
